import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import InputField from '../components/ui/InputField';
import TextAreaField from '../components/ui/TextAreaField';
import Button from '../components/ui/Button';

const DevletGiderReportForm = ({ onDataChange }) => {
  const { t } = useTranslation();
  const [reportInfo, setReportInfo] = useState({
    departmentName: '',
    staffName: '',
    staffId: '',
    reportMonth: new Date().toISOString().slice(0, 7)
  });

  const [expenses, setExpenses] = useState([
    { date: new Date().toISOString().split('T')[0], expenseItem: '', category: 'Per Diem', amount: 0 }
  ]);

  const [notes, setNotes] = useState('');

  useEffect(() => {
    const totalExpense = expenses.reduce((sum, item) => sum + item.amount, 0);
    onDataChange({
      ...reportInfo,
      expenses,
      notes,
      totalExpense,
      date: new Date().toLocaleDateString()
    });
  }, [reportInfo, expenses, notes, onDataChange]);

  const handleExpenseChange = (index, field, value) => {
    const newExpenses = [...expenses];
    newExpenses[index][field] = value;
    setExpenses(newExpenses);
  };

  const totalExpense = expenses.reduce((sum, item) => sum + item.amount, 0);

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl p-6 lg:p-8 border border-gray-200 dark:border-gray-700 shadow-sm space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <InputField label="Department Name" name="departmentName" value={reportInfo.departmentName} onChange={(e) => setReportInfo({ ...reportInfo, departmentName: e.target.value })} placeholder="e.g., Ministry of Health" required />
        <InputField label="Staff Name" name="staffName" value={reportInfo.staffName} onChange={(e) => setReportInfo({ ...reportInfo, staffName: e.target.value })} placeholder="Employee name" />
        <InputField label="Staff ID" name="staffId" value={reportInfo.staffId} onChange={(e) => setReportInfo({ ...reportInfo, staffId: e.target.value })} placeholder="Employee ID" />
        <InputField label="Report Month" name="reportMonth" type="month" value={reportInfo.reportMonth} onChange={(e) => setReportInfo({ ...reportInfo, reportMonth: e.target.value })} />
      </div>

      <div>
        <h3 className="text-xl font-bold text-[#111418] dark:text-white mb-4">Official Expenses</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead className="border-b border-gray-200 dark:border-gray-700">
              <tr>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400">Date</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400">Expense Item</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400">Category</th>
                <th className="p-3 text-sm font-medium text-gray-600 dark:text-gray-400 text-right">Amount</th>
                <th className="p-3 w-12"></th>
              </tr>
            </thead>
            <tbody>
              {expenses.map((expense, index) => (
                <tr key={index} className="border-b border-gray-200 dark:border-gray-700">
                  <td className="p-2"><input className="form-input w-full bg-transparent border-0 focus:ring-0 p-2" type="date" value={expense.date} onChange={(e) => handleExpenseChange(index, 'date', e.target.value)} /></td>
                  <td className="p-2"><input className="form-input w-full bg-transparent border-0 focus:ring-0 p-2" type="text" value={expense.expenseItem} onChange={(e) => handleExpenseChange(index, 'expenseItem', e.target.value)} placeholder="e.g., Travel, Accommodation" /></td>
                  <td className="p-2">
                    <select className="form-select w-full bg-transparent border-0 focus:ring-0 p-2" value={expense.category} onChange={(e) => handleExpenseChange(index, 'category', e.target.value)}>
                      <option>Per Diem</option>
                      <option>Travel</option>
                      <option>Accommodation</option>
                      <option>Supplies</option>
                      <option>Other</option>
                    </select>
                  </td>
                  <td className="p-2"><input className="form-input w-full bg-transparent border-0 focus:ring-0 p-2 text-right" type="number" min="0" step="0.01" value={expense.amount} onChange={(e) => handleExpenseChange(index, 'amount', parseFloat(e.target.value) || 0)} /></td>
                  <td className="p-2 text-center"><button onClick={() => setExpenses(expenses.filter((_, i) => i !== index))} className="text-gray-400 hover:text-red-500" disabled={expenses.length === 1}><span className="material-symbols-outlined text-xl">delete</span></button></td>
                </tr>
              ))}
            </tbody>
          </table>
          <Button onClick={() => setExpenses([...expenses, { date: new Date().toISOString().split('T')[0], expenseItem: '', category: 'Per Diem', amount: 0 }])} variant="ghost" icon="add_circle" className="mt-4">Add Expense</Button>
        </div>
      </div>

      <div className="flex justify-end">
        <div className="w-full max-w-sm space-y-3 bg-gray-50 dark:bg-gray-900 p-4 rounded-lg">
          <div className="flex justify-between items-center pt-3"><span className="text-lg font-bold text-[#111418] dark:text-gray-100">Total Expense</span><span className="text-lg font-bold text-primary">${totalExpense.toFixed(2)}</span></div>
        </div>
      </div>

      <TextAreaField label={t('form.notes')} value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Official notes, approvals..." rows={3} />
    </div>
  );
};

export default DevletGiderReportForm;
